<template>
  <div
    class="customCheck"
    :class="{
      ['customCheck_checked']: isChecked,
      ['customCheck_disabled']: disabled,
    }"
    @click.stop="handleCheck"
  >
    <div
      class="customCheck_icon"
      :class="{ ['customCheck_icon--no_circle']: noCircle }"
      :style="{ width: size, height: size }"
    >
      <div v-if="checkIndex" class="customCheck_index">{{ indexValue }}</div>
      <CheckIconSVG
        v-else
        :no-circle="noCircle"
        :color="color"
        :check-color="checkColor"
        :size="size"
        class="customCheck_icon-check"
      />
    </div>
    <span class="customCheck_label" @click.stop="handleCheck">
      <slot></slot>
    </span>
    <slot name="append"></slot>
  </div>
</template>

<script>
import CheckIconSVG from '@/components/icons/CheckIconSVG.vue';
export default {
  name: 'CustomCheck',
  components: { CheckIconSVG },
  props: {
    value: {
      type: Boolean,
      default: () => false,
    },
    size: {
      type: String,
      default: '24px',
    },
    color: {
      type: String,
      default: '#0075c2',
    },
    checkColor: {
      type: String,
      default: '#fff',
    },
    noCircle: {
      type: Boolean,
      default: false,
    },
    checkIndex: {
      type: Boolean,
      default: false,
    },
    indexValue: {
      type: Number,
      default: 0,
    },
    onlyCheck: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isChecked: false,
    };
  },
  watch: {
    value(val) {
      this.isChecked = val;
    },
  },
  created() {
    this.isChecked = this.value;
  },
  methods: {
    handleCheck() {
      if (this.disabled) {
        return;
      }
      if (this.onlyCheck && this.isChecked) {
        return;
      }
      this.isChecked = !this.isChecked;
      this.$emit('input', this.isChecked);
    },
  },
};
</script>
<style lang="scss" scoped>
.customCheck {
  display: flex;
  align-items: center;
  cursor: pointer;

  &_icon {
    cursor: pointer;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid #989898;
    margin-right: 5px;
    position: relative;
    &-check {
      position: absolute;
      top: -1px;
      left: -1px;
      display: none;
    }
    &--no_circle {
      border: none;
    }
  }
  &_index {
    width: 26px;
    height: 24px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    margin-top: 1px;
    padding-top: 1px;
  }
  &_checked {
    .customCheck_icon {
      border-color: transparent;
      .customCheck_icon-check {
        display: block;
      }
    }
    .customCheck_index {
      color: #fff;
      border-radius: 5px;
      background-color: #0075c2;
    }
  }
  &_label {
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #4b4b4b;
  }

  &_disabled {
    opacity: 0.5;
    cursor: auto;

    .customCheck_icon,
    .customCheck_label {
      cursor: auto;
    }

    &.customCheck .customCheck_label {
      color: #999 !important;
    }
  }
}
</style>
